module.exports = __webpack_public_path__ + "img/SNRG.7c5e79df.svg";